<ng-container [ngSwitch]="status">
  <div *ngSwitchCase="'IN_PROGRESS'"
       class="status status-inProgress">
    <em class="fa-duotone fa-solid fa-spinner-third"></em>
    <span>{{ 'WORKFLOWS.in_progress' | translate | uppercase }}</span>
  </div>
  <div *ngSwitchCase="'VALIDATED'"
       class="status status-validated">
    <em class="fa fa-light fa-check-circle"></em>
    <span>{{ 'WORKFLOWS.validated' | translate | uppercase }}</span>
  </div>
  <div *ngSwitchCase="'REJECTED'"
       class="status status-rejected">
    <em class="fa fa-light fa-exclamation-circle"></em>
    <span>{{ 'WORKFLOWS.rejected' | translate | uppercase }}</span>
  </div>
  <div *ngSwitchCase="'CANCELED'"
       class="status status-canceled">
    <em class="fa fa-light fa-ban"></em>
    <span>{{ 'WORKFLOWS.canceled' | translate | uppercase }}</span>
  </div>
  <div *ngSwitchCase="'DELETED'"
       class="status status-deleted">
    <em class="fa fa-light fa-trash-alt"></em>
    <span>{{ 'WORKFLOWS.deleted' | translate | uppercase }}</span>
  </div>
  <div *ngSwitchCase="'ERROR'"
       class="status status-error">
    <em class="fa fa-light fa-times-circle"></em>
    <span>{{ 'WORKFLOWS.error' | translate | uppercase }}</span>
  </div>
</ng-container>
